import { supabase } from "../supabase";
import { DESIGN_SAVE_LIMIT, FILE_SAVE_LIMIT } from "../config/features";

/* 저장 개수 (휴지통 제외). 디자인은 정식 저장만 센다 — 임시저장은 따로 7일 뒤 정리된다. */
export async function countSaved(userId) {
  const [d, f] = await Promise.all([
    supabase
      .from("designs")
      .select("id", { count: "exact", head: true })
      .eq("user_id", userId)
      .not("is_deleted", "is", true)
      .not("is_draft", "is", true),
    supabase
      .from("user_files")
      .select("id", { count: "exact", head: true })
      .eq("user_id", userId)
      .eq("is_deleted", false),
  ]);
  return { designs: d.count || 0, files: f.count || 0 };
}

/* 휴지통에서 되살렸을 때 10개를 넘는지. 넘으면 그 종류 이름을 돌려준다(없으면 null). */
export async function restoreOverLimit(userId, { designs = 0, files = 0 }) {
  const now = await countSaved(userId);
  if (designs > 0 && now.designs + designs > DESIGN_SAVE_LIMIT) return { kind: "designs", limit: DESIGN_SAVE_LIMIT };
  if (files > 0 && now.files + files > FILE_SAVE_LIMIT) return { kind: "files", limit: FILE_SAVE_LIMIT };
  return null;
}
